import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import PageCampaign from '@pages/offers/ui/PageCampaign';

export const Route = createFileRoute('/_auth/_layout/offers/')({
  component: () => <PageCampaign />,
});
